import React, { useState } from "react";
import Slider from "react-slick";
import {
  IoMdArrowDropleftCircle,
  IoMdArrowDroprightCircle,
} from "react-icons/io";
import Photoframe from "../multimedia/Photoframe";
import {
  show01,
  show02,
  show03,
  show04,
  show05,
  show06,
  show07,
  show08,
  show09,
  show10,
  show11,
  show12,
  show13,
  show14,
} from "../../assets";

function NextArrow(props) {
  const { onClick } = props;

  return (
    <div
      className="w-25 h-25 bg-slate-400 rounded-full hover:bg-white duration-300 text-6xl text-black hover:text-red-600 flex justify-center items-center
    absolute top-1/2 -right-16 cursor-pointer z-10"
      onClick={onClick}
    >
      <IoMdArrowDroprightCircle />
    </div>
  );
}

function PrevArrow(props) {
  const { onClick } = props;
  return (
    <div
      className="w-25 h-25 bg-slate-400 rounded-full hover:bg-white duration-300 text-6xl text-black hover:text-red-600 flex justify-center items-center
    absolute top-1/2 -left-16 cursor-pointer z-10"
      onClick={onClick}
    >
      <IoMdArrowDropleftCircle />
    </div>
  );
}

// const Sliders = () => {
//   const [dotActive, setDotActive] = useState(0);

//   var settings = {
//     dots: true,
//     infinite: true,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     nextArrow: <NextArrow />,
//     prevArrow: <PrevArrow />,
//     autoplay: true,
//     speed: 2000,
//     autoplaySpeed: 4000,
//     cssEase: "linear",
//     beforeChange: (prev, next) => {
//       setDotActive(next);
//     },
//     appendDots: (dots) => (
//       <div
//         style={{
//           borderRadius: "10px",
//           padding: "10px",
//         }}
//       >
//         <ul
//           style={{
//             display: "flex",
//             gap: "15px",
//             justifyContent: "center",
//             marginTop: "20px",
//           }}
//         >
//           {" "}
//           {dots}{" "}
//         </ul>
//       </div>
//     ),
//     customPaging: (i) => (
//       <div
//         style={
//           i === dotActive
//             ? {
//                 width: "12px",
//                 height: "12px",
//                 color: "blue",
//                 background: "white",
//                 borderRadius: "50%",
//                 cursor: "pointer",
//               }
//             : {
//                 width: "12px",
//                 height: "12px",
//                 color: "blue",
//                 background: "gray",
//                 borderRadius: "50%",
//                 cursor: "pointer",
//               }
//         }
//       ></div>
//     ),
//   };
function Sliders() {
  const [dotActive, setDotActive] = useState(0);
  var settings = {
    dots: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 4000,
    cssEase: "linear",
    beforeChange: (prev, next) => {
      setDotActive(next);
    },
    appendDots: (dots) => (
      <div
        style={{
          borderRadius: "10px",
          padding: "10px",
        }}
      >
        <ul
          style={{
            display: "flex",
            gap: "15px",
            justifyContent: "center",
            marginTop: "20px",
          }}
        >
          {" "}
          {dots}{" "}
        </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={
          i === dotActive
            ? {
                width: "12px",
                height: "12px",
                color: "blue",
                background: "white",
                borderRadius: "50%",
                cursor: "pointer",
              }
            : {
                width: "12px",
                height: "12px",
                color: "blue",
                background: "gray",
                borderRadius: "50%",
                cursor: "pointer",
              }
        }
      ></div>
    ),
    responsive: [
      {
        breakpoint: 1540,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 639,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="slider-container">
      <Slider {...settings}>
        <div className="px-2">
          <Photoframe title="Show1" des="2024 stage" img={show01} />
        </div>
        <div className="px-2">
          <Photoframe title="Show2" des="2024 stage" img={show02} />
        </div>
        <div className="px-2">
          <Photoframe title="Show3" des="2024 stage" img={show03} />
        </div>
        <div className="px-2">
          <Photoframe title="Show4" des="2024 stage" img={show04} />
        </div>
        <div className="px-2">
          <Photoframe title="Show5" des="2024 stage" img={show05} />
        </div>
        <div className="px-2">
          <Photoframe title="Show6" des="2024 stage" img={show06} />
        </div>
        <div className="px-2">
          <Photoframe title="Show7" des="2024 stage" img={show07} />
        </div>
        <div className="px-2">
          <Photoframe title="Show8" des="2024 stage" img={show08} />
        </div>
        <div className="px-2">
          <Photoframe title="Show9" des="2024 stage" img={show09} />
        </div>
        <div className="px-2">
          <Photoframe title="Show10" des="2024 stage" img={show10} />
        </div>
        <div className="px-2">
          <Photoframe title="Show11" des="2024 stage" img={show11} />
        </div>
        <div className="px-2">
          <Photoframe title="Show12" des="2024 stage" img={show12} />
        </div>
        <div className="px-2">
          <Photoframe title="Show13" des="2024 stage" img={show13} />
        </div>
        <div className="px-2">
          <Photoframe title="Show14" des="2024 stage" img={show14} />
        </div>
      </Slider>
    </div>
  );
}

export default Sliders;
